/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<
    ReadonlyArray<Types.UnderwriterEmployeeSortInput> | Types.UnderwriterEmployeeSortInput
  >;
  where?: Types.InputMaybe<Types.UnderwriterEmployeeFilterInput>;
}>;

export type CrmManagement_SalesCoverage_UnderwriterEmployeesQuery = {
  readonly __typename?: 'Query';
  readonly underwriterEmployees?: {
    readonly __typename?: 'UnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly email1?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly coveredAccountsCount: number;
      readonly email2?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly isActive: boolean;
        readonly email?: string | null;
        readonly name?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
  order?: Types.InputMaybe<
    ReadonlyArray<Types.UnderwriterEmployeeSortInput> | Types.UnderwriterEmployeeSortInput
  >;
  where?: Types.InputMaybe<Types.UnderwriterEmployeeFilterInput>;
}>;

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery = {
  readonly __typename?: 'Query';
  readonly adminUnderwriterEmployees?: {
    readonly __typename?: 'AdminUnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly employeeKey: string;
      readonly name?: string | null;
      readonly email1?: string | null;
      readonly status: Types.RolodexRecordStatus;
      readonly coveredAccountsCount: number;
      readonly email2?: string | null;
      readonly modifiedByUserName?: string | null;
      readonly modifiedOn: string;
      readonly userAccount?: {
        readonly __typename?: 'UserAccount';
        readonly isActive: boolean;
        readonly email?: string | null;
        readonly name?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type UnderwriterEmployeeFragment = {
  readonly __typename?: 'UnderwriterEmployee';
  readonly employeeKey: string;
  readonly name?: string | null;
  readonly email1?: string | null;
  readonly status: Types.RolodexRecordStatus;
  readonly coveredAccountsCount: number;
  readonly email2?: string | null;
  readonly modifiedByUserName?: string | null;
  readonly modifiedOn: string;
  readonly userAccount?: {
    readonly __typename?: 'UserAccount';
    readonly isActive: boolean;
    readonly email?: string | null;
    readonly name?: string | null;
  } | null;
};

export const UnderwriterEmployeeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_SalesCoverage_UnderwriterEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_SalesCoverage_UnderwriterEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UnderwriterEmployeeSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UnderwriterEmployeeFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'underwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeesDocument, options);
}
export function useCrmManagement_SalesCoverage_UnderwriterEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeesDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_UnderwriterEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
  CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeesQuery | undefined,
  CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeesDocument, options);
}
export type CrmManagement_SalesCoverage_UnderwriterEmployeesQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_UnderwriterEmployeesQuery
>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeesLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_UnderwriterEmployeesLazyQuery
>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeesSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_UnderwriterEmployeesSuspenseQuery
>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeesQueryResult = Apollo.QueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeesQuery,
  CrmManagement_SalesCoverage_UnderwriterEmployeesQueryVariables
>;
export const CrmManagement_SalesCoverage_AdminUnderwriterEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_SalesCoverage_AdminUnderwriterEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UnderwriterEmployeeSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UnderwriterEmployeeFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUnderwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UnderwriterEmployee' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UnderwriterEmployee' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UnderwriterEmployee' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'employeeKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coveredAccountsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedOn' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  > &
    (
      | {
          variables: CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeesDocument, options);
}
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeesDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery | undefined,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeesDocument, options);
}
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery
>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesLazyQuery
>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesSuspenseQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeesSuspenseQuery>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryResult = Apollo.QueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQuery,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeesQueryVariables
>;
